export default __webpack_public_path__ + "static/media/summerschool.2a832a4f.png";